<template>
    <div id="stu">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <headers :title="title"></headers>
            <template v-if="question.length">
                <div class="img-list"
                     v-if="dept_type == 2 && imgList.length">
                    <img :src="item"
                         v-for="(item,index) in imgList"
                         :for="index"
                         alt="">
                    <span @click="previewImg">点击查看学生作答结果图片</span>

                </div>
                <mathCom :questions="question"
                         :sid="sid"
                         v-if="sid==21||sid==22"></mathCom>
                <chinese :questions="question"
                         :sid="sid"
                         v-else></chinese>
            </template>
            <template v-else>
                <div class="nodata">
                    <noResouse :text="'暂无试题'"></noResouse>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import headers from "COMPONENTS/base/header.vue";
import noResouse from 'COMPONENTS/noResouse.vue';
import loadings from "COMPONENTS/base/loadingS.vue";
import chinese from "./chinese/detail.vue";
import mathCom from "./math/detail.vue";
export default {
    components: {
        // simpleResult,
        loadings,
        noResouse,
        headers,
        chinese,
        mathCom
    },
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            title: this.$route.query.name,
            cid: this.$route.query.cid,
            sid: this.$route.query.sid,
            is_qz: Number(this.$route.query.is_qz) || 0,
            is_qm: Number(this.$route.query.is_qm) || 0,
            dept_type: Number(this.$route.query.dept_type) || 0,
            userId: this.$route.query.userId,
            loading: false,
            question: [],

            yData_knowledge: [],
            yData_score: [],
            xData_knowledge: [],
            haveMore: true,
            array: [],
            echartStyle: {
                width: '15rem',
                height: '10.5rem'
            },
            lineArray: [],
            score: this.$route.query.score,
            rate: this.$route.query.rate,
            imgList: [],//学生拍照上传的图片，只有2022下期末活动、2023上开学检测 初中数学才有
            taskType: this.$route.query.taskType,
            hd_type: this.$route.query.hd_type
        }
    },
    created () {
        let url = ''
        if (this.sid == 21) {
            url = '/maths/check/task/stu_detail'
        }
        if (this.sid == 51) {
            url = '/chinese/check/user/task/question'
        }
        this.array = JSON.parse(localStorage.getItem('teaTaskUnitData'));


        let data = {
            message_id: this.cid,
            user_id: this.userId,
            sid: this.sid,
        }
        // 2022下期中
        if (this.is_qz) {
            data.is_activity = this.is_qz
        }
        // 2022下期末
        if (this.is_qm) {
            data.is_activity = this.is_qm
        }
        // 2022寒假
        if (this.taskType == '2022winter') {
            data.is_activity = 3
        }
        // 2022寒假
        if (this.taskType == '2023winter' || this.taskType == '2024winter') {
            data.is_activity = 11
        }
        // 2023上开学检测
        if (this.taskType == '2023kxjc') {
            data.is_activity = 4
        }
        // 2023上阶段检测
        if (this.taskType == '2023jdjc') {
            data.is_activity = 5
        }
        // 2023上期中检测
        if (this.hd_type) {
            data.is_activity = this.hd_type
        }
        this.loading = true
        this.$http.post(API_URL_TASK_API + url, data).then(res => {
            if (res.data.response == 'ok') {
                res = res.data;
                if (this.sid == 21) {
                    this.question = res.data;
                    this.imgList = res.data[0].text_img
                }
                if (this.sid == 51) {
                    this.question = res.data.question;
                }


            }
            this.loading = false
        });

    },
    mounted () {

    },
    methods: {
        setIndex (score) {
            let num = score == 0 ? 0 : parseInt(score / 20);
            if (score == 100) {
                num = 4;
            }
            return num;
        },
        previewImg () {
            if (this.inApp) {
                this.appFunction("ys_preview_imgs", `${this.imgList.join("-")},0`);
            } else {
                this.$nextTick(() => {
                    this.$imagePreview({
                        images: this.imgList,
                        index: 0,
                        defaultOpt: {
                            bgOpacity: 1,
                            showHideOpacity: true,
                            errorMsg: '<div class="pswp__error-msg">图片加载失败</div>',
                            tapToClose: true, // 点击上层图层关闭预览
                        }
                    });
                })
            }
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.box {
    width: 600px / $ppr;
    margin: 0 auto 30px / $ppr;
    background: #fff;
    padding: 30px / $ppr 30px / $ppr 46px / $ppr;
    border-radius: 16px / $ppr;
    h3 {
        font-size: 30px / $ppr;
        margin-bottom: 24px / $ppr;
        line-height: 56px / $ppr;
        padding-left: 48px / $ppr;
        font-weight: bold;
        position: relative;
        i {
            position: absolute;
            display: block;
            top: 50%;
            left: 0;
            margin-top: -17px / $ppr;
            width: 32px / $ppr;
            height: 32px / $ppr;
            background: url("./img/icon03.png") 0 0 no-repeat;
            background-size: 100% 100%;
            // vertical-align: middle;
            // margin-right:16px/$ppr;
        }
        i.score {
            background: url("./img/icon04.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}
#stu {
    overflow: hidden;
}
#chart {
    margin-top: 30px / $ppr;
}
.nodata {
    width: 660px / $ppr;
    margin: 0 auto;
}
.scoreChartWarp {
    width: 600px / $ppr;
    margin: 0 auto;
    overflow-x: auto;
}
.img-list {
    background-color: #fff;
    position: relative;
    width: 600px / $ppr;
    padding: 30px / $ppr;
    margin: 0 auto 30px / $ppr;
    border-radius: 16px / $ppr;
    margin-top: 30px / $ppr;
    position: relative;
    span {
        display: block;
        position: absolute;
        top: 30px / $ppr;
        left: 30px / $ppr;
        right: 30px / $ppr;
        bottom: 30px / $ppr;
        background: rgba(0, 0, 0, 0.3);
        color: #fff;
        text-align: center;
        line-height: 260px / $ppr;
    }
    img {
        width: 100%;
        height: 260px / $ppr;
        display: none;
        &:nth-child(1) {
            display: block;
        }
    }
}
</style>